import { Pipe, PipeTransform } from '@angular/core';

import { odsIcons } from '@/app/assets/icon/ods-icon';

@Pipe({
  name: 'scanTypeIcon',
  standalone: true,
})
export class ScanTypeIconExtension implements PipeTransform {
  transform(scanType: number): string {
    switch (scanType) {
      case 1: {
        return odsIcons.Scan;
      }
      case 2: {
        return odsIcons.ConnectorCheck;
      }
      case 3: {
        return odsIcons.Aux;
      }
      case 4: {
        return odsIcons.Vfl;
      }
      case 31: {
        return odsIcons.Realtime;
      }
      case 99: {
        return odsIcons.StopAll;
      }
      case 101: {
        return odsIcons.Monitoring;
      }
      case 102: {
        return odsIcons.MonitoringStop;
      }
      case 131: {
        return odsIcons.MonitoringReset;
      }
      case 201: {
        return odsIcons.SorConverter;
      }
      default: {
        return odsIcons.Empty;
      }
    }
  }
}
